import { makeStyles } from '@material-ui/core';
const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
  path: {
    fill: '#7df3e1',
  },
});
const LogoJikken = () => {
  const classes = useStyles();

  return (
    <img  className={classes.path} src="/jikken-logo.png" width={150} alt="Logo remoto" />
  );
};

export default LogoJikken;
